import { ProcessingOverlay } from '@components'

import { BorderRadius, Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { AccountFromTemplateModalActions } from '../../../AccountFromTemplateModalActions'
import { AccountFromTemplateModalHeading } from '../../../AccountFromTemplateModalHeading'
import { useUpdateAccountFromTemplateForm } from '../../contexts'
import { UpdateAccountFromTemplateForm } from '../UpdateAccountFromTemplateForm'

export const UpdateAccountFromTemplateModalComponent = (modalProps: ModalProps): ReactElement => {
  const { t } = useTranslation()
  const { closeModal, isResetDisabled, isSaveDisabled, isUpdating, resetForm, submitForm } =
    useUpdateAccountFromTemplateForm()

  return (
    <Modal {...modalProps} size="s">
      {isUpdating && <ProcessingOverlay borderRadius={BorderRadius.R16} />}
      <Modal.Header>
        <AccountFromTemplateModalHeading
          subtitle={t('coa.account_from_base_form.modal.edit_subtitle')}
          title={t('add_account_modal.title_edit')}
        />
      </Modal.Header>
      <Modal.Body>
        <UpdateAccountFromTemplateForm />
      </Modal.Body>
      <Modal.Footer>
        <AccountFromTemplateModalActions
          isResetDisabled={isResetDisabled}
          isSaveButtonDisabled={isSaveDisabled}
          onClose={closeModal}
          onReset={resetForm}
          onSubmit={submitForm}
          saveLabel={t('save')}
        />
      </Modal.Footer>
    </Modal>
  )
}
